exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n * Title:   Custom Style File\r\n * Author:  http://themeforest.net/user/soaptheme \r\n */\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/~/css-loader?{"sourceMap":false,"importLoaders":1}!D:/ptrans/front-end-customer/~/postcss-loader?{"ident":"postcss"}!D:/ptrans/front-end-customer/src/assets/css/custom.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/custom.css
// module chunks = 2